import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header = () => {
  return <header className="bg-white" data-id="element-551">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-552"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-553">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-554">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-555">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-556">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-557">
          <div className="text-xs text-gray-400 font-sans" data-id="element-558">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-559">
          <div className="text-left" data-id="element-560">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-561">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-562">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-563">
        <div className="max-w-4xl mx-auto" data-id="element-564">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-565">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-566">
            Nurse Practitioner Investigates: Do 'Earthing' Bed Sheets Actually
            Work, or Is It Another Wellness Scam?
          </h1>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-567">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-568">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-569" />
            </div>
            <div className="flex-1" data-id="element-570">
              <div className="flex items-center" data-id="element-571">
                <div className="font-medium text-gray-900 text-lg" data-id="element-572">
                  By Patricia Chen, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-573">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-574" />
                  <span className="text-xs ml-1 font-medium" data-id="element-575">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-576">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-577">
                <div className="flex items-center mr-4" data-id="element-578">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-579" />
                  <span data-id="element-580">11 min read</span>
                </div>
                <div className="flex items-center" data-id="element-581">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-582" />
                  <span data-id="element-583">24,867 views</span>
                </div>
              </div>
            </div>
          </div>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-584">
            After 30 years in medicine, I've seen every "miracle cure" come and
            go. So when I found out about "earthing" or "grounding" bed sheets,
            I decided to run a 6-month investigation. What I discovered will
            save you hundreds of dollars – and might actually change your sleep.
          </p>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-585">
            <div className="mb-1 flex items-center" data-id="element-586">
              <span className="font-medium mr-2" data-id="element-587">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-588">
              <span className="font-medium mr-2" data-id="element-589">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-590">
        <div className="max-w-4xl mx-auto" data-id="element-591">
          <div className="sm:flex items-center" data-id="element-592">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-593">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" alt="Patricia Chen, RN, MSN in hospital corridor" className="w-full rounded-lg shadow-md" data-id="element-594" />
            </div>
            <div className="sm:w-2/3" data-id="element-595">
              <p className="text-sm text-gray-700 mb-2" data-id="element-596">
                <span className="font-bold" data-id="element-597">Patricia Chen, RN, MSN</span> has
                spent three decades in clinical practice specializing in
                integrative medicine approaches. As the former Head of
                Integrative Medicine at Cedar Sinai Medical Center, she has
                evaluated hundreds of wellness products and alternative
                treatments throughout her career.
              </p>
              <p className="text-sm text-gray-700" data-id="element-598">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;